import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-558ed844"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description-header-title"
}, [/*#__PURE__*/_createElementVNode("span", null, "编辑数据字典分类")], -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description-header-content"
}, [/*#__PURE__*/_createElementVNode("span", null, "数据字典分类信息")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_form_page = _resolveComponent("form-page");
  const _directive_permission = _resolveDirective("permission");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, {
    description: _withCtx(() => [_hoisted_1, _hoisted_2]),
    _: 1
  }, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_form_page, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.formModel,
      "label-width": "120px",
      rules: $data.formRules,
      class: "normal-form",
      ref: "formRef"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "字典分类名称",
        prop: "name"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formModel.name = $event),
          placeholder: "请输入字典分类名称"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "字典分类编码",
        prop: "code"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.code,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.formModel.code = $event),
          disabled: "",
          placeholder: "请输入字典分类编码"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "备注"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.remark,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formModel.remark = $event),
          placeholder: "请输入备注",
          autosize: {
            minRows: 2,
            maxRows: 4
          },
          type: "textarea"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: $options.submitForm
        }, {
          default: _withCtx(() => [_createTextVNode(" 保存 ")]),
          _: 1
        }, 8, ["onClick"])), [[_directive_permission, ['dictionary_edit']]]), _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = () => {
            this.$router.go(-1);
          })
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  })]);
}